// CHILDS : childs, components --> for attach directive (place to attach global)
import Vue from 'vue'

// Vue.component('test', ()=>import('./../asahi/Test'))
Vue.component('new-home', require('./../asahi/NewHome').default)
// Vue.component('navbar', require('./sepakat/childs/Navbar')); 
// Vue.component('footer-side', require('./sepakat/childs/FooterSide'));
// Vue.component('inspiring-info', require('./childs/InspiringInfo'));
// Vue.component('home', require('./kiospay/Home'));
// Vue.component('nav-button', require('./childs/NavButton'));
// Vue.component('menu-inline', require('./clinic/childs/MenuInline'));
// Vue.component('menu-pop-up', require('./clinic/childs/MenuPopUp'));
// Vue.component('command-button',require('./template/CommandButton'));
// Vue.component('patient-queue-count-view',require('./clinic/patient-queue-count/PatientQueueCountView'));
Vue.component('loading-block',() => import('./../asahi/childs/LoadingBlock'));
// Vue.component('scroll-to-top',require('./childs/ScrollToTop'));

import PrettyCheckbox from 'pretty-checkbox-vue'; //related scss : @import '~pretty-checkbox/src/pretty-checkbox.scss';
Vue.use(PrettyCheckbox);


//Other Vue 
import Paginate from 'vuejs-paginate'
Vue.component('paginate', Paginate);

// Vue Multiselect
import Multiselect from 'vue-multiselect'
Vue.component('multiselect', Multiselect);

// Vue.component('th-sorter', require('./template/table/ThSorter.vue'));
// Vue.component('bs4-input-date-picker', require('./template/form/Bs4InputDatePicker.vue')); //<-- turn off for a while
// Vue.component('bs4-input-date-time-picker', require('./template/form/Bs4InputDateTimePicker.vue')); //<-- turn off for a while

